import { createApi } from "@reduxjs/toolkit/query/react";
import { APICall } from "@/config/NetworkUtility";

const customBaseQuery = async ({ url, method, body, params }) => {
    try {
        const cleanedParams = Object.entries(params || {}).filter(
            ([, value]) => value !== undefined && value !== null && value !== "",
        );
        const query = cleanedParams.length
            ? new URLSearchParams(Object.fromEntries(cleanedParams)).toString()
            : "";
        const endpoint = query ? `${url}?${query}` : url;

        const result = await APICall(method, body ?? null, endpoint);

        return { data: result };
    } catch (error) {
        return {
            error: {
                status: error?.response?.status || 500,
                data: error?.response?.data || error?.message || "Request failed",
            },
        };
    }
};

export const terminalMappingApi = createApi({
    reducerPath: "terminalMappingApi",
    baseQuery: customBaseQuery,
    tagTypes: ["TerminalMapping"],

    endpoints: (builder) => ({
        getTerminalMappings: builder.query({
            query: (params = {}) => ({
                url: "v1/TerminalMapping/GetTerminalMapping",
                method: "get",
                params,
            }),
            transformResponse: (response) => ({
                rows: Array.isArray(response?.data) ? response.data : [],
                pagination: response?.pagination || {},
            }),
            providesTags: ["TerminalMapping"],
        }),

        insertTerminalMapping: builder.mutation({
            query: (payload) => ({
                url: "v1/TerminalMapping/InsertTerminalMapping",
                method: "post",
                body: payload,
            }),
            transformResponse: (response) => response?.data || response,
            invalidatesTags: ["TerminalMapping"],
        }),

        updateTerminalMapping: builder.mutation({
            query: (payload) => ({
                url: "v1/TerminalMapping/UpdateTerminalMapping",
                method: "post",
                body: payload,
            }),
            transformResponse: (response) => response?.data || response,
            invalidatesTags: ["TerminalMapping"],
        }),
    }),
});

export const {
    useGetTerminalMappingsQuery,
    useInsertTerminalMappingMutation,
    useUpdateTerminalMappingMutation,
} = terminalMappingApi;
